var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useCallback, forwardRef, } from 'react';
import { autoUpdate, flip, hide, offset, shift, useHover, useId, useDismiss, useFloating, useInteractions, useTransitionStyles, useRole, } from '@floating-ui/react';
import Button from '@storeblocks/button';
import { PopoverBase, Popper, Header, Description, Content, ButtonWrapper, } from './styled';
export const Popover = forwardRef((_a, ref) => {
    var { title = '', placement = 'right', icon = 'information', showOn = 'press', size = 16, children, buttonProps, iconColor, closeButtonAriaLabel = 'Close | Lukk' } = _a, props = __rest(_a, ["title", "placement", "icon", "showOn", "size", "children", "buttonProps", "iconColor", "closeButtonAriaLabel"]);
    const [isOpen, setIsOpen] = useState(false);
    const toggle = useCallback(() => setIsOpen(!isOpen), [isOpen]);
    const close = useCallback(() => setIsOpen(false), []);
    const { x, y, reference, floating, strategy, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        whileElementsMounted: autoUpdate,
        middleware: [
            shift(),
            offset(8),
            hide(),
            flip({
                fallbackPlacements: ['left', 'top', 'bottom'],
            }),
        ],
        placement,
        strategy: 'fixed',
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([
        useRole(context),
        useDismiss(context),
        useHover(context, {
            enabled: showOn === 'hover',
        }),
    ]);
    const { isMounted, styles } = useTransitionStyles(context, {
        duration: 200,
    });
    const popoverId = useId();
    const headerId = useId();
    const contentId = useId();
    return (React.createElement(PopoverBase, Object.assign({}, props, { ref: ref }),
        React.createElement(Button, Object.assign({ "aria-label": icon, type: "button", variant: "icon", iconLeft: icon, color: iconColor, size: size, onClick: toggle }, buttonProps, { ref: reference }, getReferenceProps())),
        isMounted && (React.createElement(Popper, Object.assign({ id: popoverId }, getFloatingProps({
            ref: floating,
            style: Object.assign({ position: strategy, top: y !== null && y !== void 0 ? y : 0, left: x !== null && x !== void 0 ? x : 0 }, styles),
            'aria-labelledby': title ? headerId : contentId,
            'aria-describedby': contentId,
        })),
            React.createElement(Content, null,
                title && React.createElement(Header, { id: headerId }, title),
                React.createElement(Description, { id: contentId }, children)),
            showOn === 'press' && (React.createElement(ButtonWrapper, null,
                React.createElement(Button, { "aria-label": closeButtonAriaLabel, type: "button", variant: "icon", iconLeft: "close", onClick: close })))))));
});
export default Popover;
